<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-group">
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "infos",
    cardSetLink: "infos",
    item: null,
    fields: [
      {
        col: " col-12 col-md-12",
        key: "info_project",
        labelKey: "project",
        label: "Выберите проект",
        type: "select",
        modal: "info_project",
        selectKey: "title",
      },
      {
        col: " col-12 col-md-12",
        key: "type",
        labelKey: "type",
        label: "Тип",
        type: "static_radio",
        items: [
          { id: "error", title: "Ошибка" },
          { id: "info", title: "Инфо" },
        ],
      },
      {
        key: "name",
        col: "col-12",
        label: "Название",
        labelKey: "name",
        isMultiLang: true,
        type: "field",
      },
      {
        key: "description",
        label: "Описание",
        labelKey: "description",
        type: "html",
        textType: "text",
        isMultiLang: true,
      },
      {
        key: "position",
        label: "Позиция (чем больше, тем выше)",
        labelKey: "position",
        type: "field",
        textType: "number",
      },
    ],
  }),

  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
    },
  },
};
</script>
<style>
</style>
